import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('ALBUM').plugin(axiosPlugin);

let fetchAlbumAction = redux.fetchActionGetOne();

export const fetchAlbum = (albumId, query = {}) => fetchAlbumAction(`/albums/${albumId}?${queryString.stringify(query)}`);
export const resetAlbum = () => redux.actions.reset();

export const album = redux.reducer();



